module.exports = __webpack_public_path__ + "img/Banner_Home_3.a26d5f0d.png";